import RestClient from '../../../../api/axiosInterceptor';
import { pharmacyLoginActions } from '../../../actions/user/pharmacy/Account/login';

/**
 * Helper function to create asynchronous actions for Redux.
 * @param {string} actionType - The action type to dispatch.
 * @param {function} apiCall - The API call function to make the request.
 */
const createAsyncAction = (actionType, apiCall) => async (dispatch) => {
	try {
		dispatch({ type: actionType.REQUEST });

		// Make the API call and wait for the response
		const response = await apiCall();

		dispatch({
			type: actionType.SUCCESS,
			payload: response.data,
		});
		console.log(response.data);
	} catch (error) {
		const errorMessage =
			error.response && error.response.data && error.response.data.error
				? error.response.data.error
				: error.message;
		dispatch({
			type: actionType.FAILURE,
			error: errorMessage,
		});
		console.error(errorMessage);
	}
};

export const loginPharmacy = (formData) => async (dispatch) => {
	try {
		dispatch({ type: pharmacyLoginActions.LOGIN_PHARMACY.REQUEST });
		const response = await RestClient.post('/pharmacy/login/', formData);
		dispatch({
			type: pharmacyLoginActions.LOGIN_PHARMACY.SUCCESS,
			payload: response.data,
		});
		return { success: true, data: response.data };
	} catch (error) {
		const errorMessage =
			error.response && error.response.data && error.response.data.error
				? error.response.data.error
				: error.message;
		dispatch({
			type: pharmacyLoginActions.LOGIN_PHARMACY.FAILURE,
			error: errorMessage,
		});
		console.error(errorMessage);
		return { error: { message: errorMessage } };
	}
};
